import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CkEditorComponent } from "../ck-editor/ck-editor.component";
import {
EventTypesSelectorCardComponent
} from '../components/templates/event-types-selector-card/event-types-selector-card.component';
import { TextareaModule } from '../components/templates/textarea/textarea.module';
import { DaveDmsModule } from '../dave-dms-module/dave-dms.module';
import { PreviewModule } from '../dave-dms-module/dave-dms/preview/preview.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveFileExplorerModule } from '../dave-file-explorer/dave-file-explorer.module';
import { DaveHistoryModule } from '../dave-history-module/dave-history.module';
import { DaveListCardModule } from '../dave-list-card/dave-list-card.module';
import { DaveSelectFileFromDmsModule } from '../dave-select-file-from-dms/dave-select-file-from-dms.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PipesModule } from '../dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { IconPipeModule } from '../dave-utils-module/icon-pipe/icon-pipe.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { OptionsScrollDirective } from '../directives/options-scroll/options-scroll.directive';
import { IncludesPipe } from "../helper/includes.pipe";
import { LengthPipe } from '../helper/length.pipe';
import { MatMenuHeaderComponent } from "../mat-menu-header/mat-menu-header.component";
import { TimePickerSelectComponent } from "../time-picker-select/time-picker-select.component";
import { EndTimeDirective } from "../time-span-picker-select/end-time.directive";
import { StartTimeDirective } from "../time-span-picker-select/start-time.directive";
import { TimeSpanPickerSelectComponent } from "../time-span-picker-select/time-span-picker-select.component";
import { DaveLoadingModule } from './../dave-loading/dave-loading.module';
import { EmailClientComponent } from './components/email-client.component';
import { EmailEditorCloseDialogComponent } from './components/email-editor-close-dialog/email-editor-close-dialog.component';
import { EmailFileUploadFileSystemComponent } from './components/email-file-upload/email-file-upload-file-system/email-file-upload-file-system.component';
import { EmailFileUploadReportsComponent } from './components/email-file-upload/email-file-upload-reports/email-file-upload-reports.component';
import { EmailPreviewComponent } from './components/email-preview/email-preview/email-preview.component';
import { EmailViewComponent } from './components/email-view/email-view.component';
import { EventFromEmailComponent } from './components/event-from-email/event-from-email.component';
import { DaveEmailRoutingModule } from './dave-email-routing.module';
import { MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import {
  SelectSearchPagedOptionsComponent
} from '../dave-utils-module/select-search/components/select-search-paged-options/select-search-paged-options.component';

@NgModule({
    declarations: [EmailClientComponent, EventFromEmailComponent, EmailViewComponent, EmailFileUploadReportsComponent, EmailFileUploadFileSystemComponent, EmailPreviewComponent, EmailEditorCloseDialogComponent],
    imports: [
        NgClickOutsideDirective,
        DaveEmailRoutingModule,
        CommonModule,
        MatCardModule,
        MatAutocompleteModule,
        MatChipsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        FontAwesomeModule,
        // CKEditorModule,
        AppButtonModule,
        MatSelectModule,
        DaveSharedComponentsModule,
        DropzoneModule,
        DaveDmsModule,
        SimplebarAngularModule,
        MatDialogModule,
        DragDropModule,
        MatListModule,
        MatTableModule,
        RouterModule,
        MatTooltipModule,
        FormsModule,
        MatTabsModule,
        MatSidenavModule,
        MatToolbarModule,
        IconPipeModule,
        MatInputModule,
        MatButtonModule,
        PreviewModule,
        MatMenuModule,
        TextareaModule,
        SelectSearchModule,
        ScrollingModule,
        TableVirtualScrollModule,
        DaveFileExplorerModule,
        DaveListCardModule,
        MatExpansionModule,
        DaveSelectFileFromDmsModule,
        DaveHistoryModule,
        DaveLoadingModule,
        MatCheckboxModule,
        MatTreeModule,
        DaveDoubleIconModule,
        PipesModule,
        MatProgressBarModule,
        OptionsScrollDirective,
        EventTypesSelectorCardComponent,
        CkEditorComponent,
        EventTypesSelectorCardComponent,
        MatMenuHeaderComponent,
        IncludesPipe,
        EndTimeDirective,
        MatDatepickerModule,
        StartTimeDirective,
        TimePickerSelectComponent,
        TimeSpanPickerSelectComponent,
        LengthPipe,
        MatLegacyPaginatorModule,
        SelectSearchPagedOptionsComponent,
    ],
    exports: [EmailViewComponent, EmailPreviewComponent],
})
export class DaveEmailModule {}
